module.exports = __webpack_public_path__ + "static/boat6-6fe6a97197c239f8b1f97eaa4b274b2f.jpg";